import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'ard-general-shared-message-set-buttons-text-dialog',
	templateUrl: './general-shared-message-set-buttons-text-dialog.component.html'
})
export class GeneralSharedMessageSetButtonsTextDialogComponent implements OnInit {
	viewLoading: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<GeneralSharedMessageSetButtonsTextDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { 
	}

	ngOnInit() {
	}

	onNoClick(): void {
		this.dialogRef.close(false);
	}

	onYesClick(): void {
		this.viewLoading = true;
		this.dialogRef.close(true);
	}

	onYesDovizliClick(): void {
		this.dialogRef.close("DetayliDovizli");
	}

	onNoDovizliClick(): void {
		this.dialogRef.close("BasitDovizli");
	}
}
